import styled from "styled-components"
import { Style } from "../../styles"

const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    padding-bottom: ${Style.spacing.x3};
  }
`

export default AccordionContainer